/*
 * @Author: lbh
 * @Date: 2025-09-19 10:23:08
 * @LastEditors: lbh
 * @LastEditTime: 2025-10-15 18:16:01
 * @Description: file content
 */
export default {
  menu: {
    "Large font": "字體放大",
    "Default font": "字體縮小",
    "Total Amonut": "合計",
    "Decimal bill": "賬單小數",
    "Service Fee": "服務費",
    "Thank You For Coming": "謝謝光臨",
    "Tabel X Order has been checked out": "{X}號桌訂單已結賬",
    "We hope to serve you again next time": "我們希望下一次可以再爲您服務",
    "The payment has been received": "賬單已完成",
    "View membership benefits": "查看會員權益，儹積分抵消費",
    "Join Member To Enjoy Benefits": "加入會員立享優惠，攢積分抵消費",
    Check: "查看",
    "Join Member": "加入會員",
    "X Minutes before last order": "距離最後落單還有{X}分",
    "Your last food order has not been delivered yet": "您上一次食品還未送單",
    "Send out food order": "點我送單",
    "X times order": "第{X}次落單",
    "Table No.": "檯號",
    Pending: "待確認",
    Notice: "公告",
    "Food are not available now": "暫無可售食品",
    pc: "/份",
    "I have read, understood and agreed to the above terms and conditions":
      "我已閱讀並同意程序條款及相關私隱條款",
    Confirm: "確定",
    "Please select the number of guests": "請選擇就餐人數",
    "Save to Album": "保存至相冊",
    Cancel: "取消",
    "Order payment voucher, please keep it properly":
      "訂單支付憑證，請妥善保管！！",
    升级: "升級",
    点餐: "點餐",
    The_self_fetching_function_is_not_available_please_contact_the_merchant:
      "自取功能不可使用,請聯絡餐廳",
    The_delivery_function_is_not_available_please_contact_the_merchant:
      "外送功能不可使用,请联系商家",
    Table_name: "檯號:",
    Person: "人數",
    My_order: "我的訂單",
    loading_in: "加載中...",
    No_order_at_present: "暫時沒有訂單",
    Opening_time: "開單時間",
    Unbind: "解綁",
    LastOrderTime: "最後落單時間",
    EndTime: "交檯時間",
    appTotal: "總計",
    Bill_Decimal: "賬單小數",
    appDiscount: "折扣",
    Service_amount: "服務費",
    appAmount: "總金額",
    距离X米: "距離{X}米",
    自取: "自取",
    外送: "外送",
    已售X份: "已售{X}份",
    ONE_remaining: "剩餘{X}份",
    Amount: "金額",
    Also_need_to_click_$ONE_food: "還需點選{X}元食物",
    Next: "下一步",
    Remaining_QS: "還差 {X} 起送",
    shopCartN: "加購食品",
    Empty: "清空",
    Share: "一起點餐",
    Share_the_qr_Code: "分享QR Code",
    大字版: "大字版",
    Choose_a_language: "選擇語言",
    Logout: "登出",
    Login: "登入",
    Not_logged_in: "未登錄",
    Shop_Menu: "餐牌", // 餐牌
    Cold_Chain_Delivery: "冷凍派送",
    Takeout: "外送",
    Pick_up: "自取",
    Warm_prompt: "溫馨提示",
    Max_Number: "已達到最大限制數量!",
    Over_maximum_order_quantity: "超出食品組最大限制",
    Shop_closed: "商戶休息中",
    商户繁忙中: "商戶繁忙中",
    服务未开启: "服務未開啟",
    Takeaway_service_is_not_open: "外送服務未開啟",
    Not_in_the_scope_of_delivery: "不在配送範圍",
    Empty_cart: "清空購物車?",
    Please_quit_and_try_again: "請退出後重試!",
    UnbindSuccess: "解綁成功!",
    关闭: "關閉",
    结算: "結算",
    餐盒费: "餐盒費",
    共X份: "共{X}份",
    立即支付: "立即支付",
    送单成功: "送單成功!",
    确认门店地址: "確認門店地址",
    店铺: "店鋪:",
    营业时间: "營業時間:",
    地址: "地址:",
    可加購X份: "可加購{X}份",
    加購以下商品享折扣: "加購以下商品享折扣",
    返回: "返回",
    撞: "撞",
    減: "減",
    此食品不參與折扣: "此食品不參與折扣",
    返回首頁將清空購物車是否返回: "返回首頁將清空購物車,是否返回?",
  },
};
